import React from 'react';
import PropType from 'prop-types';

/*
 * Active Media Name
 * ---------------------
 * This small module shows the name of the currently active media
 */

class AudioPlayerComponentActiveMediaName extends React.Component {
  render() {
    const dataActiveShow = this.props.dataActiveShow;
    const dataPodcast = this.props.dataPodcast;
    const audioState = this.props.audioState;
    const isExpanded = this.props.isExpanded;
    const isMuted = this.props.isMuted;
    const isPaused = this.props.isPaused;

    let typeText = 'ON AIR NOW';
    if (audioState === 'podcast on' || audioState === 'podcast off') {
      typeText = 'PODCAST';
    }

    if (!dataPodcast && !dataActiveShow) {
      typeText = 'FETCHING Data';
    }

    let activeName = 'Loading...';

    if (dataActiveShow && dataActiveShow.show_name) {
      activeName = dataActiveShow.show_name;

      if(dataActiveShow.substitute_presenter) {
        activeName = activeName + ' with ' + dataActiveShow.substitute_presenter;
      }
    }

    if (audioState === 'podcast on' || audioState === 'podcast off') {
      activeName = dataPodcast.podcast_name;
    }

    const expandedClass =
      isExpanded === true
        ? `po-audio-player__component-active-media__name--center-align`
        : `po-audio-player__component-active-media__name--left-align`;

    let marqueeClass = ``;
    if (activeName.length > 40) {
      marqueeClass = 'u-text-marquee marquee-10';
    } else {
      const screenWidth = window.innerWidth || document.body.clientWidth;
      const paddingSpace = 60;
      let textSpace = 0.55 * screenWidth - paddingSpace;
      if (textSpace === 0) textSpace = 100;
      if (textSpace > 342 && !isExpanded) textSpace = 342;
      if (textSpace > 670 && isExpanded) textSpace = 670;
      const charWidth = activeName.length * 17;

      if (screenWidth <= 320 && screenWidth > 0) {
        if (charWidth / textSpace > 2.25) {
          marqueeClass = 'u-text-marquee marquee-20';
        } else if (charWidth / textSpace > 1.45) {
          marqueeClass = 'u-text-marquee marquee-10';
        } else {
          marqueeClass = 'u-text-marquee marquee-8';
        }
      } else if (screenWidth !== 0) {
        if (charWidth > textSpace) {
          if (charWidth / textSpace > 2.25) {
            marqueeClass = 'u-text-marquee marquee-20';
          } else if (charWidth / textSpace > 1.45) {
            marqueeClass = 'u-text-marquee marquee-10';
          } else {
            marqueeClass = 'u-text-marquee marquee-8';
          }
        }
      } else {
        marqueeClass = 'u-text-marquee marquee-10';
      }
    }

    if (isPaused) {
      marqueeClass += ' u-text-marquee--paused';
    }

    let unmuteButton = null;

    const clickFunction = () => {
      window.unmuteAudioPlayer(false);
    };

    if (
      isMuted &&
      (audioState === 'stream on' || audioState === 'podcast on')
    ) {
      unmuteButton = (
        <div
          onClick={clickFunction}
          style={{ display: 'inline-block', cursor: 'pointer' }}
        >
          [MUTED]
        </div>
      );
    }

    return (
      <div
        className={`po-audio-player__component-active-media__name ${
          isExpanded
            ? 'po-audio-player__component-active-media__name--is-expanded'
            : 'po-audio-player__component-active-media__name--is-minified'
        }`}
      >
        <div
          className={`po-audio-player__component-active-media__name__type-text ${expandedClass}`}
        >
          {typeText} {unmuteButton}
        </div>
        <div
          className={`po-audio-player__component-active-media__name__name-text ${expandedClass} ${marqueeClass}`}
        >
          <span>{activeName}</span>
        </div>
      </div>
    );
  }
}

AudioPlayerComponentActiveMediaName.propTypes = {
  dataActiveShow: PropType.object.isRequired,
  audioState: PropType.string.isRequired,
  dataPodcast: PropType.object.isRequired,
  isExpanded: PropType.bool.isRequired,
  isMuted: PropType.bool,
  isPaused: PropType.bool,
};

export default AudioPlayerComponentActiveMediaName;
